import { getCurrentInstance } from 'vue';
import { emitter } from 'shared/helpers/mitt';

/**
 * Custom hook to track events
 * @returns {Function} The track function
 */
export const useTrack = () => {
  const vm = getCurrentInstance();
  if (!vm) throw new Error('must be called in setup');

  return vm.proxy.$track;
};

/**
 * Emits a toast message event using a global emitter.
 * @param {string} message - The message to be displayed in the toast.
 * @param {Object|null} action - Optional action descriptor. Supported shapes:
 *   - { type: 'link', to, message }              → renders a router-link
 *   - { type: 'button', message, onClick }       → renders a clickable button
 * @param {number|null} duration - Optional toast lifetime override in ms.
 *   Falls back to SnackbarContainer's default (2500ms) when null. Use a longer
 *   duration for toasts with an action so the user has time to react.
 */
export const useAlert = (message, action = null, duration = null) => {
  emitter.emit('newToastMessage', { message, action, duration });
};
